import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'

export default class {
  @observable data = {
    uid: 0,
    userInfo: {
      countryId: 0
    },
    now: 0,
    loading: false,
    loadMore: false
  }

  @action async setUid(uid) {
    this.data.uid = uid
  }

  @action async GetUserInfoWeb(uid) {
    if (uid == '' || uid == 0) {
      return
    }
    let map = {
      uid: uid
    }
    let d = await http.post('/web/MyAccountInfo', map)
    if (d && d.code == 0 && d.res && d.res.uid > 0) {
      this.data.userInfo = d.res
      return d
    }
  }
}



// WEBPACK FOOTER //
// src/store/activity/ladies.js